var luxxTranslations = JSON.parse(document.getElementById('LuxxTranslations')?.textContent || '{}');
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const trigger = document.querySelector('[data-cart-trigger]');
  if (!drawer || !trigger || typeof drawer.showModal !== 'function') return;
  const content = drawer.querySelector('[data-cart-drawer-content]');
  const status = drawer.querySelector('[data-drawer-status]');
  const closeButton = drawer.querySelector('[data-drawer-close]');
  let busy = false, opener = trigger, oldOverflow = '';
  trigger.setAttribute('aria-haspopup', 'dialog');
  trigger.setAttribute('aria-controls', drawer.id);
  trigger.setAttribute('aria-expanded', 'false');
  const setBusy = value => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-drawer-quantity], [name="update"], [name="checkout"]').forEach(el => el.disabled = value);
  };
  const syncCount = count => {
    let badge = trigger.querySelector('.bag-count');
    if (count > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'bag-count'; badge.setAttribute('aria-hidden', 'true'); trigger.append(badge); }
      badge.textContent = count;
    } else if (badge) badge.remove();
    trigger.setAttribute('aria-label', luxxTranslations["Panier"] + ' (' + count + ')');
  };
  async function refresh() {
    const url = new URL(drawer.dataset.sectionUrl, location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(luxxTranslations["Le panier ne peut pas être actualisé."]);
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = parsed.querySelector('[data-cart-drawer-content]');
    if (!next) throw new Error(luxxTranslations["Le panier ne peut pas être actualisé."]);
    content.replaceChildren(...Array.from(next.childNodes).map(node => document.importNode(node, true)));
    syncCount(Number(next.dataset.count || 0));
  }
  async function update(removeKey) {
    if (busy) return;
    const quantities = [...drawer.querySelectorAll('[data-drawer-quantity]')];
    if (quantities.some(input => !input.checkValidity())) { quantities.find(input => !input.checkValidity()).reportValidity(); return; }
    const focusedId = document.activeElement?.id;
    const updates = Object.fromEntries(quantities.map(input => [input.dataset.key, Number(input.value)]));
    if (removeKey) updates[removeKey] = 0;
    setBusy(true); status.textContent = luxxTranslations["Mise à jour…"];
    try {
      const response = await fetch(drawer.dataset.updateUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates, attributes: { 'Gravure du cadeau offert': '', 'Cadeau gravé dès 80 €': '' } }) });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : luxxTranslations["La modification a échoué. Veuillez réessayer."]);
      syncCount(result.item_count);
      await refresh();
      status.textContent = luxxTranslations["Panier mis à jour."];
      if (drawer.open) (focusedId && drawer.querySelector('#' + CSS.escape(focusedId)) || closeButton).focus();
    } catch (error) { status.textContent = error.message + luxxTranslations[" Vous pouvez utiliser « Voir le panier »."]; }
    finally { setBusy(false); }
  }
  trigger.addEventListener('click', async event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (drawer.open) return;
    opener = document.activeElement; oldOverflow = document.documentElement.style.overflow;
    drawer.showModal(); document.documentElement.style.overflow = 'hidden'; trigger.setAttribute('aria-expanded', 'true');
    setBusy(true); status.textContent = luxxTranslations["Chargement du panier…"];
    try { await refresh(); status.textContent = ''; }
    catch { status.textContent = luxxTranslations["Actualisation indisponible. Ouvrez « Voir le panier » pour vérifier votre commande."]; }
    finally { setBusy(false); }
  });
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = oldOverflow;
    trigger.setAttribute('aria-expanded', 'false');
    if (opener?.isConnected) opener.focus();
  });
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-drawer-close]')) { drawer.close(); return; }
    if (event.target === drawer) { const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) drawer.close(); }
    const remove = event.target.closest('[data-drawer-remove]');
    if (remove) { event.preventDefault(); update(remove.dataset.key); }
  });
  drawer.addEventListener('change', event => { if (event.target.matches('[data-drawer-quantity]')) update(); });
  drawer.addEventListener('submit', event => {
    if (!event.target.matches('[data-drawer-form]') || event.submitter?.name === 'checkout') return;
    event.preventDefault(); update();
  });
})();